/**
 * Created by Daniela on 23/01/2017.
 */
import { Injectable } from '@angular/core';

import { apiName } from "./data.service";
import { RestService } from "../../../core/services/rest.service";
import { TipoAjuste } from "./tipo-ajuste.model";

@Injectable()
export class TipoAjusteApiService {

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: TipoAjuste, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: TipoAjuste, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        let filter: any = {"order":"tipo"};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        this._restService.onGetPostId(apiName, objectId, {}, done);
    }

    onGetApiUrl() {
        return apiName;
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tipo-ajustes/shared/tipo-ajuste-api.service.ts
 **/